import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true, timeout: 25000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sahoi_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.code === "ECONNABORTED") {
      err.message = "The request took too long and was cancelled. Please try again.";
    }
    return Promise.reject(err);
  }
);

export default api;
